/*
 * @Autor: 李建鹏
 * @Date: 2022-07-28 23:46:11
 * @LastEditTime: 2022-08-09 19:25:14
 * @Description: 图表配置
 */

/**
 * 获取最大最小数
 * @param yData       y轴数据
 * @param type   计算最小数值 0: 最小 1： 最大
 * @param isDeleteLast 是否删除最后一位 默认不删除
 * @param originalPrice 本机价格
 * @returns {{width: *, height: *}}
 */
export const isMaxNumber = ({ yData, isDeleteLast = false, originalPrice }) => {
  if (!yData) return
  const [...maxData] = [].concat(yData.slice(0, isDeleteLast ? yData.length : yData.length), [
    originalPrice || 0,
  ])
  return Math.ceil((Math.max(...maxData) || 0) / 100) * 100
}
// $ 获取最小数
export const isMinNumber = (data, originalPrice, isNeedMin) => {
  const newData = (originalPrice && [].concat(data, [originalPrice])) || data
  const setNumber = parseInt((Math.min(...newData) || 0) / 100) * 100
  const minNumber =
    setNumber -
    (Math.pow(10, setNumber.toString().length - 2) < 100
      ? 100
      : Math.pow(10, setNumber.toString().length - 2))
  return isNeedMin ? (minNumber <= 0 ? 0 : minNumber) : setNumber
  // return setNumber
}
// $ 处理 X 轴数据
const formatterXdata = (params) => {
  const { xData, platform, conditionIdx } = params
  const formatterXdata = []
  xData &&
    xData.map((item, index) => {
      formatterXdata[index] = {
        value: item,
        textStyle: {
          color: index === conditionIdx ? (platform == 'zz' ? '#000' : '#111') : '#999',
        },
      }
    })
  return formatterXdata
}
/**
 * 图表配置
 * @param xData       x轴数据
 * @param yData       y轴数据
 * @param isZZ        true： 转转 false 找靓机
 * @param originalPrice 本机价格
 * @returns {}
 */
export const chartConfig = (params) => {
  const { xData, yData, originalPrice, conditionIdx = -1, platform, isNeedMin = false } = params
  return {
    grid: {
      top: '16%',
      left: '-1%',
      right: '0%',
      bottom: '8%',
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: true,
        axisLine: {
          show: false,
        },
        axisLabel: {
          margin: 14,
          interval: 0,
          textStyle: {
            color: '#999',
            fontSize: 10,
          },
        },
        axisTick: {
          show: false,
        },
        data: formatterXdata({ xData, platform, conditionIdx }),
      },
    ],
    yAxis: [
      {
        min: isMinNumber(yData, originalPrice || 0, isNeedMin),
        // scale: true,
        // max: isMaxNumber({ yData, isDeleteLast: true, originalPrice }),
        axisTick: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            // type: 'dashed',
            color: 'rgba(226, 226, 226, 0.3)',
            width: 1,
          },
        },
        axisLine: {
          // show: true,
          lineStyle: {
            color: 'rgb(2,185,208)',
          },
        },
        axisLabel: {
          interval: 0,
          // formatter: (value) => `￥${String(value)}`,
          formatter: (value) => {
            return [`{a| ￥}`, `{b|${value}}`].join('')
          },
          rich: {
            b: {
              fontSize: 10,
              padding: [0, 0, 0, -1],
            },
          },
          textStyle: {
            color: '#999',
            fontSize: 10,
          },
        },
      },
    ],
  }
}
